import { useQuery } from "@tanstack/react-query";
import { analysisReportOptions, analysisInfoOptions } from "../lib/queries";
import { ReportLoadStatus } from "../store";

export const useAnalysis = (analysisId: string) => {
  const infoQuery = useQuery(analysisInfoOptions(analysisId));
  const reportQuery = useQuery(analysisReportOptions(analysisId));

  let loadStatus: ReportLoadStatus;
  let errorMsg: string | null = null;

  if (reportQuery.isLoading) {
    loadStatus = ReportLoadStatus.REQUEST_IN_PROGRESS;
  } else if (reportQuery.isError) {
    loadStatus = ReportLoadStatus.ERROR_LOADING_REPORT;
    errorMsg =
      reportQuery.error instanceof Error
        ? reportQuery.error.message
        : "An unknown error occurred";
  } else if (reportQuery.isSuccess) {
    loadStatus = ReportLoadStatus.REPORT_LOADED;
  } else {
    loadStatus = ReportLoadStatus.REQUEST_IN_PROGRESS;
  }

  return {
    reportData: reportQuery.data ?? null,
    analysisInfo: infoQuery.data ?? null,
    loadStatus,
    errorMsg,
  };
};
